import { CheckoutSummaryPill } from "components/UI/atoms";
import { OrderTermsAndConditions, Tooltip } from "components/UI/molecules";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";
import { normalizeURL } from "utils/strings";
import { OrderRedemption } from "..";
import "./index.scss";

export const OrderSummaryItem = ({
  price,
  value,
  electronic,
  electronic_voucher,
  title,
  card_id,
  image_url,
  affiliate_url,
  orderAmount,
  brand_terms,
  isLettuce,
  isApple
}) => {
  const paid = toMoneyWithTwoDecimalDigits(orderAmount ?? price);
  return (
    <div className="order-summary-item" data-testid="order-summary-item">
      <div>
        <img className="summary-image" alt={title} src={image_url} />
      </div>

      <div className="summary-content">
        <div className="card-title">
          <p className="summary-brand">
            {title}
            <span className="summary-price">
              <b>{toMoneyWithTwoDecimalDigits(value)}</b> <i>for</i>{" "}
              <b>{paid}</b>
            </span>
          </p>
          <div>
            {affiliate_url && (
              <a className="new-button" href={normalizeURL(affiliate_url)}>
                shop now
              </a>
            )}
          </div>
        </div>
        {(electronic || electronic_voucher) && (
          <div className="tags" data-testid="card-tags">
            {electronic && !isLettuce && (
              <Tooltip
                customClassName="tooltip"
                content="Electronic delivery for online use only"
                position="top"
              >
                <CheckoutSummaryPill text="Egift" />
              </Tooltip>
            )}
            {electronic_voucher && (
              <Tooltip
                customClassName="tooltip"
                content="Can be printed and redeemed in-store"
                position="top"
              >
                <CheckoutSummaryPill text="Voucher" />
              </Tooltip>
            )}
          </div>
        )}

        <div className="delivery">
          <span className="bold-value">{"Card ID "}</span>
          <Tooltip
            customClassName="tooltip-with-title"
            content={
              <>
                <h5>What is a Card ID?</h5>
                <p>
                  A unique reference number provided by GCX that corresponds to
                  each specific gift card.
                </p>
              </>
            }
          >
            <span className="dot">?</span>
          </Tooltip>
          : {card_id}
        </div>

        <OrderRedemption
          electronic={electronic}
          electronic_voucher={electronic_voucher}
          isApple={isApple}
          isLettuce={isLettuce}
        />
        <OrderTermsAndConditions
          brand={title}
          termsAndConditions={brand_terms}
        />
      </div>
    </div>
  );
};
